<template>
  <path
    d="M6 5.00024H3C2.45 5.00024 2 5.45024 2 6.00024V18.0002C2 18.5502 2.45 19.0002 3 19.0002H6C6.55 19.0002 7 18.5502 7 18.0002V6.00024C7 5.45024 6.55 5.00024 6 5.00024ZM20 5.00024H17C16.45 5.00024 16 5.45024 16 6.00024V18.0002C16 18.5502 16.45 19.0002 17 19.0002H20C20.55 19.0002 21 18.5502 21 18.0002V6.00024C21 5.45024 20.55 5.00024 20 5.00024ZM13 5.00024H10C9.45 5.00024 9 5.45024 9 6.00024V18.0002C9 18.5502 9.45 19.0002 10 19.0002H13C13.55 19.0002 14 18.5502 14 18.0002V6.00024C14 5.45024 13.55 5.00024 13 5.00024Z"
  />
</template>
